import {MENU_SOUND_MANAGER} from './MenuSoundManager';

class Registry {
  setGameScene(gameScene) {
    this.gameScene = gameScene;
  }

  resetGameScene(gameScene) {
    // При пересоздании игры destroy старой сцены может сработать ПОСЛЕ init новой —
    // не сбрасываем регистрацию, если она уже принадлежит другой (новой) сцене
    if (gameScene && this.gameScene && this.gameScene !== gameScene) {
      return;
    }
    this.gameScene = null;
  }
  getGameScene() {
    return this.gameScene;
  }
  getSoundManager() {
    return this.gameScene?.soundManager || MENU_SOUND_MANAGER;
  }
  getHexGridRenderer() {
    return this.gameScene?.hexGridRenderer;
  }
}

export const REGISTRY_SINGLETON = new Registry();
